import React from 'react'
import {auth} from '../firebase.js';

function Signout(props) {
    return (
     
          <div onClick={() => auth.signOut()}>{props.children}</div> 
     
    )
}

export default Signout;
